import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { toast } from 'sonner';
import { 
  FileText, Plus, Download, Copy, Eye, Edit, Trash2,
  Mail, MessageCircle, Cake, GraduationCap, Calendar, Users,
  Heart, Star, PartyPopper, ExternalLink
} from 'lucide-react';

const Templates = () => {
  const [templates] = useState([
    {
      id: '1',
      nome: 'Feliz Aniversário',
      categoria: 'aniversario',
      icon: Cake,
      previa: 'Parabéns! Que seu dia seja repleto de alegrias e realizações...',
    },
    {
      id: '2',
      nome: 'Boas-vindas Matrícula',
      categoria: 'matricula',
      icon: GraduationCap,
      previa: 'Seja bem-vindo(a) à família DNA Hub! Estamos muito felizes...',
    },
    {
      id: '3',
      nome: 'Convite Evento',
      categoria: 'evento',
      icon: Calendar,
      previa: 'Você está convidado(a) para um evento especial em nossa escola...',
    },
    {
      id: '4',
      nome: 'Reunião de Pais',
      categoria: 'reuniao',
      icon: Users,
      previa: 'Convidamos os pais e responsáveis para a reunião pedagógica...',
    },
    {
      id: '5',
      nome: 'Dia das Mães',
      categoria: 'datas',
      icon: Heart,
      previa: 'Feliz Dia das Mães! Que este dia seja repleto de amor e gratidão...',
    },
    {
      id: '6',
      nome: 'Formatura',
      categoria: 'formatura',
      icon: Star,
      previa: 'Parabéns pela conquista! Você chegou ao fim de mais uma etapa...',
    },
  ]);

  const getCategoriaColor = (categoria) => {
    const cores = {
      aniversario: 'bg-pink-100 text-pink-800',
      matricula: 'bg-blue-100 text-blue-800',
      evento: 'bg-purple-100 text-purple-800',
      reuniao: 'bg-orange-100 text-orange-800',
      datas: 'bg-red-100 text-red-800',
      formatura: 'bg-yellow-100 text-yellow-800',
    };
    return cores[categoria] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <FileText className="w-7 h-7 text-purple-500" />
            Templates de Mensagens
          </h1>
          <p className="text-muted-foreground mt-1">
            Modelos prontos para suas comunicações
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => window.open('https://www.canva.com/', '_blank')}>
            <ExternalLink className="w-4 h-4 mr-2" />
            Criar no Canva
          </Button>
          <Button className="bg-purple-600 hover:bg-purple-700">
            <Plus className="w-4 h-4 mr-2" />
            Novo Template
          </Button>
        </div>
      </div>

      {/* Grid de Templates */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {templates.map(template => {
          const Icon = template.icon;
          return (
            <Card key={template.id} className="hover:shadow-lg transition-all cursor-pointer group">
              <CardContent className="p-4">
                <div className="flex items-start justify-between mb-3">
                  <div className="p-2 bg-purple-100 rounded-lg group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-purple-600" />
                  </div>
                  <Badge className={getCategoriaColor(template.categoria)}>
                    {template.categoria}
                  </Badge>
                </div>
                <h3 className="font-semibold mb-2">{template.nome}</h3>
                <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
                  {template.previa}
                </p>
                <div className="flex gap-2">
                  <Button variant="outline" size="sm" className="flex-1">
                    <Eye className="w-4 h-4 mr-1" />
                    Ver
                  </Button>
                  <Button variant="outline" size="sm" onClick={() => {
                    navigator.clipboard.writeText(template.previa);
                    toast.success('Copiado!');
                  }}>
                    <Copy className="w-4 h-4" />
                  </Button>
                  <Button variant="outline" size="sm">
                    <Edit className="w-4 h-4" />
                  </Button>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Dicas */}
      <Card className="bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <PartyPopper className="w-8 h-8 text-purple-600" />
            <div>
              <h3 className="font-semibold">Dica: Personalize no Canva!</h3>
              <p className="text-sm text-muted-foreground">
                Use o Canva para criar designs profissionais e personalizados para suas campanhas. 
                Clique no botão "Criar no Canva" para começar.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Templates;
